import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
    Validator
} from 'vee-validate'
let password1='';
export default {
    name: 'changepassword',
    components: {
      VueElementLoading
    },
    props: [],
    data() {
        return {
            token: '',
            newpassword: '',
            oldpassword:'',
            confirmpassword: '',
            userid: '',
            errormsg: '',
            successmsg: '',
            isLoading: false,
            previousPage: document.referrer
        }
    },
    computed: {

    },
    mounted() {
      if(this.previousPage !== window.location.href){
      window.localStorage.setItem("referrer",this.previousPage);
      this.previousPage = window.localStorage.getItem("referrer");
      }
      this.token = this.$route.params.token;
      this.checkTokenData();
    },
    methods: {

        checkTokenData(){
          this.isLoading = true;
          let input = {
            token: this.token
          };

          axios({
            method: "POST",
            url: apiUrl.api_url + "validateChangePasswordToken",
            data: input
            }).then((response) => {
              this.isLoading = false;
              if(response.data.code==200){

              }
              else{
                this.isLoading = true;
                let message = response.data.error + '. Redirecting back.'
                this.$alertify.error(message);
                window.localStorage.clear();
                window.setTimeout(()=>{
                  window.location.href = this.previousPage;
                },4000)
                this.errormsg = response.data.error;
              }
            }).catch((httpException) => {
              console.error('exception is:::::::::', httpException)
            })
        },
        changePassword(event) {
            this.isLoading = true;
            if(!this.newpassword || !this.oldpassword){
              this.$alertify.error("Require password")
              return false;
            }
            this.input = ({
                "oldpassword": this.oldpassword,
                "password": this.newpassword
            })
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'changeApplicationPassword',
                'data': this.input,
                'headers': {
                  'Authorization' : 'token ' + this.token
                }
            })
            .then((response) => {
                this.isLoading = false;
                if (response.data.code == 200) {
                    this.$alertify.success(response.data.message);
                    event.target.reset();
                    window.localStorage.clear();
                    window.setTimeout(()=>{
                    window.location.href = this.previousPage;
                    },4000);                  }
                  else if(response.data.code == 104){
                    this.$alertify.error(response.data.message);
                  } else {
                    let message = response.data.message + '. Redirecting back.'
                    this.$alertify.error(message);
                    window.localStorage.clear();
                    window.setTimeout(()=>{
                    window.location.href = this.previousPage;
                    },4000);
                    this.errormsg = response.data.message;
                }
            })
            .catch((httpException) => {
                console.error('exception is:::::::::', httpException)
            })
        },
        resetForm(){
          this.newpassword = '';
          this.oldpassword = '';
          this.confirmpassword = '';
          this.$validator.reset();
          this.errors.clear();
          window.localStorage.clear();
          window.location.href = this.previousPage;
        },
        onSubmit: function(event) {
          this.$validator.validateAll().then((result) => {
            if(result){
              this.changePassword(event);
            }
          }).catch(() => {
            console.log('errors exist', this.errors)
          });
        }

    }
}

Validator.extend('verify_password', {
    getMessage: field => "The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character and atleast 8 or more characters",
    validate: value => {
        password1=value;
        //console.log(value);
        //var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
        //console.log(strongRegex.test(value));
        return true;
    }
});
Validator.extend('verify_password1', {
    getMessage: field => "The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character and minimum 8 and maximum 16 characters.",
    validate: value => {
        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,16}$)");
        return strongRegex.test(value);
    }
});
Validator.extend('verify_password2', {
    getMessage: field => "New Password Should Not Be Same As Old Password.",
    validate: value => {
        if(password1 == value){
          return false;
        }
        return true;

    }
});



// WEBPACK FOOTER //
// ./src/views/components/changeapplicationpassword/changeapplicationpassword.component.js